import gameiomModel from "gameiom/model/gameiom-model";
import { UiDenomDisplayType } from "gameiom/wrapper/wrapper-data";
import Layers from "slotworks/graphics/layers/layers";
import ControlList from "slotworks/smart-ui/control-list";
import { Control } from "slotworks/smart-ui/controls/control";
import CreditSizeStepperControl from "slotworks/smart-ui/controls/stepper/credit-size-stepper-control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class AgsCreditSizeStepperControl extends CreditSizeStepperControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
        if (gameiomModel.denomDisplay === UiDenomDisplayType.multiplier) {
            if (ControlList.CREDIT_SIZE_STEPPER.type !== AgsCreditSizeStepperControl) {
                // remove credit_size_stepper controller, so we will not have 2 instances of the same controller
                ControlList.removeControl(ControlList.CREDIT_SIZE_STEPPER);
            }

            this.stepperComponent.formatFunction = (value) => {
                return value.toString();
            };
        }
    }
}
